import { isWeeklyCalorieDeficitDashboardEnabled } from "@/constants/feature-flags";
import { OnPlanOverviewHomePage } from "./OnPlanOverviewHomePage";
import { memo } from "react";
import { NewOverviewHomePage } from "./NewOverviewHomePage";

const OverviewPage = memo(function OverviewPage() {
  return isWeeklyCalorieDeficitDashboardEnabled() ? (
    <NewOverviewHomePage />
  ) : (
    <OnPlanOverviewHomePage />
  );
});

export default OverviewPage;
